import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";

export function NotFoundRenderer() {
    const { question } = useFieldContext();
    return (
        <div className="">
            <h1>Field <span className="px-2 bg-gray-400 rounded">{question?.field_type ?? "NULL"}</span> not found</h1>
        </div>
    )
}